module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"user-avatar":"Аватар пользователя"},"en":{"user-avatar":"User avatar"}}')
  delete Component.options._Ctor
}
